import waitUntil from 'wait-until-promise';

const TIMEOUT_MS = 60000;
const INTERVAL_MS = 100;

export const waitForPayPalCheckoutScripts = () =>
  waitUntil(
    () => window.paypal != null && window.braintree?.paypalCheckout != null,
    TIMEOUT_MS,
    INTERVAL_MS
  );
